export const promoModal = () => {
    return {
        visible: false,
        item: {},

        init() {
            // Only show if the promo hasn't been seen before
            if (!sessionStorage.getItem('promoSeen')) {
                this.visible = true;
            }
        },

        show(options) {
            this.item = {...this.item, ...options};
            this.visible = true;
        },

        toggle() {
            this.visible = !this.visible;

            // If hiding the modal, set the flag so it doesn't show again
            if (!this.visible) {
                sessionStorage.setItem('promoSeen', 'true');
            }
        },
    };
};

window.showPromoModal = (item = null) => {
    if (item) {
        window.dispatchEvent(
            new CustomEvent('promo', {
                detail: item,
            }),
        );
    }
};
